import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Formik, Field } from 'formik';
import { Button, Form } from 'react-bootstrap';
import Select from 'react-select';

import ChecklistSchoolGroupProps from 'propTypes/checklistSchoolGroup';

import ModalComponent from 'components/ModalComponent';
import ValidationErrors from 'components/forms/ValidationErrors';

import './ManageChecklistSchoolGroups.scss';

const ManageSchoolGroupModal = ({
  customers,
  id,
  location,
  name,
  customerIds,
  onSubmit
}) => {
  const initialValues = {
    name,
    location,
    customer_ids: customerIds
  };

  if (id) {
    initialValues.id = id;
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { setErrors }) => onSubmit(values, { setErrors })}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({
        values,
        errors,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue
      }) => {
        const buttons = [
          <Button
            variant='primary'
            type='submit'
            disabled={isSubmitting}
            onClick={handleSubmit}
          >
            {
              isSubmitting ? 'Submitting' : 'Submit'
            }
          </Button>
        ];

        return (
          <ModalComponent
            title='Edit School Group Details'
            className='manage-school-group-modal'
            buttons={buttons}
          >
            <form>
              <div className='form-horizontal'>
                <ValidationErrors errors={errors} fieldNames={{}} />

                <div className={classNames('mb-3 row', errors.name ? 'has-error' : null)}>
                  <Form.Label htmlFor='name'>Name</Form.Label>
                  <div className='controls'>
                    <Form.Control
                      name='name'
                      type='text'
                      onChange={handleChange}
                      value={values.name}
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.location ? 'has-error' : null)}>
                  <Form.Label htmlFor='location'>Location</Form.Label>
                  <div className='controls'>
                    <Form.Control
                      name='location'
                      type='text'
                      onChange={handleChange}
                      value={values.location}
                    />
                  </div>
                </div>

                <div className='mb-3 row'>
                  <Form.Label htmlFor='customer_ids'>Members</Form.Label>
                  <div className='controls'>
                    <Field
                      name='customer_ids'
                    >
                      {
                        () => (
                          <Select
                            clearable
                            multi
                            className='manage-school-group-modal-schools'
                            value={values.customer_ids}
                            options={
                              customers.ready ? customers.map((customer) => ({
                                value: customer.id,
                                label: customer.subdomain
                              })) : []
                            }
                            onChange={
                              (selectedCustomers) => setFieldValue('customer_ids',
                                selectedCustomers.map(({ value }) => (value)))
                            }
                          />
                        )
                      }
                    </Field>
                  </div>
                </div>
              </div>
            </form>
          </ModalComponent>
        );
      }}
    </Formik>
  );
};

ManageSchoolGroupModal.propTypes = {
  ...ChecklistSchoolGroupProps,
  customers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    subdomain: PropTypes.string
  })),
  customerIds: PropTypes.arrayOf(PropTypes.string),
  onSubmit: PropTypes.func
};

ManageSchoolGroupModal.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  id: null,
  // eslint-disable-next-line react/default-props-match-prop-types
  subdomain: '',
  // eslint-disable-next-line react/default-props-match-prop-types
  location: '',
  customers: [],
  customerIds: [],

  onSubmit: () => false
};

export default ManageSchoolGroupModal;
